import { Pack } from "./Product";

export interface Order {
  id?: string;
  userId?: string; // user also as a phone number
  productIds?: string[];
  address?: string;
  name?: string;
  phone?: string;
  governorate?: string;
  totalAmount: number;
  status: OrderState;
  history?: string[];
  createdAt?: Date;
  updatedAt?: Date;
  notes?: string;
  storeId: string;
  cart?: CartDetail[];
  deliveryCompany?: string;
  deliveryPrice?: number;
  deliveryReference?: string;
  tentativesNumber?: number;
}

export interface CartDetail {
  productId: string;
  quantity: number;
  price: number;
  selectedPack?: Pack;
}

export enum OrderState {
  PENDING = "pending",
  COMPLETED = "completed",
  TENTATIVE = "tentative",
  CANCELED = "canceled",
  RETURNED = "returned",
  DELIVERED = "delivered",
  ARCHIVED = "archived",
  CONFIRMED = "confirmed",
  UPLOADED = "uploaded",
  EXCHANGED = "exchanged",
  IN_TRANSIT = "in_transit",
  OUT_FOR_DELIVERY = "out_for_delivery",
  SHIPPED = "shipped",
}
